<template>
<div class="form-content" id="formContatti">
    <h3 class="">
    {{ option && option['title'] ? option['title'] : 'Contattaci'}}
    <small class="d-block" v-html="(option && option['subtitle'] ? option['subtitle'] : '')"></small>
    </h3>
    <form @submit="checkForm" action="javascript:;" method="post">
    <div class="my-4">
        <div class="row">
            <div class="col-12  col-md-6">
                <formgroupcomponent v-on:on-error-discard="listErrorOnSubmit.nome=null" :errorinput="listErrorOnSubmit.nome">
                    <template v-slot:default>
                        <label>Nome</label>
                        <input v-model="contatto.nome" type="text" class="form-control" />
                    </template>
                </formgroupcomponent>
            </div>
            <div class="col-12  col-md-6">
                <formgroupcomponent v-on:on-error-discard="listErrorOnSubmit.cognome=null" :errorinput="listErrorOnSubmit.cognome">
                    <template v-slot:default>
                        <label>Cognome</label>
                        <input v-model="contatto.cognome" type="text" class="form-control" />
                    </template>
                </formgroupcomponent>
            </div>
        </div>
        <formgroupcomponent v-on:on-error-discard="listErrorOnSubmit.cellulare=null" :errorinput="listErrorOnSubmit.cellulare">
            <template v-slot:default>
                <label>Cellulare</label>
                <input v-model="contatto.cellulare" type="text" class="form-control" />
            </template>
        </formgroupcomponent>
        <formgroupcomponent v-on:on-error-discard="listErrorOnSubmit.email=null" :errorinput="listErrorOnSubmit.email">
            <template v-slot:default>
                <label>Email</label>
                <input v-model="contatto.email" type="text" class="form-control" />
            </template>
        </formgroupcomponent>
        <formgroupcomponent v-on:on-error-discard="listErrorOnSubmit.oggetto=null" :errorinput="listErrorOnSubmit.oggetto">
            <template v-slot:default>
                <label>Oggetto</label>
                <input v-model="contatto.oggetto" :disabled="option && option.subtitle" type="text" class="form-control" />
            </template>
        </formgroupcomponent>
        <formgroupcomponent v-on:on-error-discard="listErrorOnSubmit.messaggio=null" :errorinput="listErrorOnSubmit.messaggio">
            <template v-slot:default>
                <label>Messaggio</label>
                <textarea v-model="contatto.messaggio"  v-bind:rows=" option && option['smallbox'] ? option['smallbox']  : 6 " style="resize:none;" type="text" class="form-control" ></textarea>
            </template>
        </formgroupcomponent>
        <div class="my-5">
            <button type="submit" class="btn btn-primary btn-block text-uppercase btn-lg"><i class="fas fa-paper-plane" aria-hidden="true"></i>&nbsp;Invia</button>
        </div>
    </div>
    </form>
</div>
</template>

<script>
    export default {
        props: {
            option : { function () { return {}}},

        },
        data: function () {
            return {
                contatto:{},
                listErrorOnSubmit:{}
            }
        },
        mounted: function() {
            if (this.option && this.option.subtitle) {
                this.contatto.oggetto = this.option.subtitle;
                this.$forceUpdate();
            }
        },
        methods: {
            checkForm() {
                httpRequest(base_url+'api/v1/contatto',this.contatto).then(onSuccess => {
                    if (onSuccess.result) {
                        this.contatto = {};
                        this.listErrorOnSubmit = {};
                        $('#formContatti').prepend(saccessAnimation());
                        scrollTo('#formContatti .success-checkmark');
                        setTimeout(function () {
                            $('.success-send-request').remove();
                            $('#modalContatti').modal('hide');
                        },5000);
                    } else {
                        this.listErrorOnSubmit = onSuccess.data;
                        this.$forceUpdate();
                    }
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
h3 {
    small { margin-top:5px}
}
</style>